import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { FeatureDetailRequestBody, FeatureDetailResponse } from "./types";

export class FeatureDetailAPI extends BaseAPI<
    FeatureDetailRequestBody,
    FeatureDetailResponse
> {
    protected route = ApiRoutes.feature.detail;
    protected method = RequestMethod.GET;
}
